export const SN_WISHLIST = 'wishlist'
export const WISH_ADD_ITEM = SN_WISHLIST + '/ADD'
export const WISH_DEL_ITEM = SN_WISHLIST + '/DEL'
export const WISH_DEL_ALL_ITEMS = SN_WISHLIST + '/DEL_ALL'
export const WISH_LOAD_WISH = SN_WISHLIST + '/LOAD'
export const SET_WISHLIST_LOADED = `${SN_WISHLIST}/SET_WISHLIST_LOADED`
export const SET_WISHLIST_ITEM_IDS = `${SN_WISHLIST}/SET_WISHLIST_ITEM_IDS`
export const WISHLIST_DEL_ITEM_ID = `${SN_WISHLIST}/WISHLIST_DEL_ITEM_ID`
export const SET_WISHLIST_START_LOAD = `${SN_WISHLIST}/SET_WISHLIST_START_LOAD`
export const SET_WISHLIST_END_LOAD = `${SN_WISHLIST}/SET_WISHLIST_END_LOAD`
